import {
  MultiSkillTagConvertResponse,
  OccupationSkillTagConvertResponse,
  SingleSkillTagConvertResponse,
} from "src/infra/api/service/skill_tag_api_convert";

export namespace Single_SkillTag {
  export enum Category {
    Category_Unknown = 0,
    // 得意フェーズ
    Category_GoodPhase = 1,
    // 組織フィット
    Category_Fit = 2,
    // 得意サービス区分
    Category_GoodServiceClassification = 3,
  }
}

export namespace Multi_SkillTag {
  export enum Category {
    Category_Unknown = 0,
    // 導入運用経験ツール
    Category_IntroductionOperation = 1,
    // 得意業界
    Category_SpecialtyIndustry = 2,
    // 海外進出
    Category_OverseasExpansion = 3,
    // プログラミング言語
    Category_Programming = 4,
    // 開発フレームワーク
    Category_DevelopFramework = 5,
    // AI専門領域
    Category_AI = 6,
    // コネクション・人脈
    Category_PersonalConnections = 7,
    // その他の経験
    Category_Other = 8,
    // CxOの経験
    Category_CXO = 9,
  }
}

export namespace Occupation_SkillTag {
  export enum Category {
    Category_Unknown = 0,
    // 営業
    Category_Sales = 1,
    // 事業開発
    Category_BusinessDevelopment = 2,
    // PR
    Category_PR = 3,
    // 広報
    Category_PublicRelations = 4,
    // 財務
    Category_Finance = 5,
    // グループマネジメント
    Category_GroupManagement = 6,
    // IR
    Category_IR = 7,
    // 管理会計
    Category_Accounting = 8,
    // 事務・アシスタント
    Category_OfficeWork_Assistant = 9,
    // 販売・サービス職
    Category_SaleService = 10,
    // 人事
    Category_HumanResource = 11,
    // コンサル
    Category_Consultant = 12,
    // 行政担当
    Category_Administrative = 13,
    // 銀行対応
    Category_Bank = 14,
    // 技術職
    Category_Technical = 15,
    // IPO準備
    Category_IPO = 16,
    // 経営
    Category_CompanyManagement = 17,
    // マーケティング
    Category_Marketing = 18,
    // 研究開発
    Category_RandD = 19,
    // 法務・コンプライアンス
    Category_LegalCompliance = 20,
  }
}

export class SingleSkillTag {
  public static from(from: SingleSkillTagConvertResponse): SingleSkillTag {
    return new SingleSkillTag(from.id, from.name, from.category);
  }

  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly category: Single_SkillTag.Category
  ) {}
}

export class MultiSkillTag {
  public static from(from: MultiSkillTagConvertResponse): MultiSkillTag {
    return new MultiSkillTag(from.id, from.name, from.category);
  }

  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly category: Multi_SkillTag.Category
  ) {}
}

export class OccupationSkillTag {
  public static from(
    from: OccupationSkillTagConvertResponse
  ): OccupationSkillTag {
    return new OccupationSkillTag(
      from.id,
      from.parentID,
      from.name,
      from.category
    );
  }

  constructor(
    public readonly id: string,
    public readonly parentID: string,
    public readonly name: string,
    public readonly category: Occupation_SkillTag.Category
  ) {}
}



// WEBPACK FOOTER //
// ./src/domain/model/skill_tag.ts